// https://github.com/simonbengtsson/jsPDF-AutoTable
function f1pdf(doc) {
  this.finalY = 0,
  this.dataBody = [],
  this.index = 0,
  this.baseY = 20,
  this.baseX = 10,
  this.pSpacing = 5,
  this.doc = doc ? doc : undefined
  this.progress_total = 0
  this.progress = 0
  this.paging = 0
}

f1pdf.prototype.addDoughnutChart = async function(d, i, w, h) {
  let start = new Date().getTime()
  var canvas = document.createElement("canvas")
  canvas.width = w
  canvas.height = h
  // console.log(canvas.width, canvas.height, d)
  // canvas.style = "width:150px;height:150px;"
  // canvas.style.width = "width:150px;height:150px;"
  // canvas.style.width = "30px"
  // canvas.style.height = "30px"
  // canvas.style.display = "none"
  canvas.id = "dynamicChart"
  document.body.appendChild(canvas)

  var ctx = document.getElementById("dynamicChart").getContext('2d');
  var draw = () => new Promise((resolve, reject) => {
    setTimeout(() => resolve(), 150)
    try {
      return new Chart(ctx, {
        type: 'doughnut',
        data: d,
        options: { legend: { display: true }, responsive: true, maintainAspectRatio: true, animation: { duration: 0 } }
      })
    } catch (error) { reject(error) }
  })
  await draw()

  console.log(new Date().getTime() - start, 'ms')

  let imageData = document.getElementById("dynamicChart").toDataURL("image/png")
  document.body.removeChild(canvas)

  return imageData
}
f1pdf.prototype.addChart = async function(d, i, w, h, type = 'line', opt = {}) {
  let f1_opt = Object.assign({}, { responsive: false, animation: { duration: 0 } }, opt)
  // console.log('draw', type, opt)

  try {
    var canvas = document.createElement("canvas")
    canvas.width = 765
    canvas.height = 382
    //canvas.style.width = "765px"
    //canvas.style.height = "382px"
    //canvas.style.display = "none"
    canvas.id = "dynamicChart"
    document.body.appendChild(canvas)

    var ctx = document.getElementById("dynamicChart").getContext('2d');

    var draw = () => new Promise((resolve, reject) => {
      try {
        new Chart(ctx, {
          type: type,
          data: d,
          options: f1_opt
        })
        setTimeout(() => resolve(), 150)
      } catch (error) {
        console.log(error)
        reject(error)
      }
    })
    await draw()

    let imageData = document.getElementById("dynamicChart").toDataURL("image/png")

    this.addImage(imageData, i, w, h)

    document.body.removeChild(canvas)
  } catch (e) {
    console.log(e)
  }
  return
}

f1pdf.prototype.addTable = function(d) {
  // { styles : { cellWidth : 40, fontStyle: 'bold', halign: 'center', lineColor: '#000',  lineWidth: 0.1, fontSize : 9 } }
  d.styles = Object.assign({}, d.styles, { font : 'Malgun' })
  this.addPage();
  d.startY = this.finalY
  d.startX = this.baseX
  this.doc.autoTable(d)
  this.finalY = this.doc.lastAutoTable.finalY + 10;
  return
}
f1pdf.prototype.addImage = function(d, i, w, h, img_type='PNG', add_page = true) {
  add_page ? this.addPage(h) : '';

  this.doc.addImage(d, img_type, this.baseX + i * 5, this.finalY, w, h, '', 'FAST');

  this.finalY += this.pSpacing + h
}
f1pdf.prototype.setText = function(s, x, y, angle='', align = 'center') {
  this.addPage();
  this.doc.text(s, x, y, angle, align)
  this.finalY += this.pSpacing
  return x
}

f1pdf.prototype.rect = function(x, y, xx, yy) { this.doc.rect(x, y, xx, yy) }
f1pdf.prototype.line = function(x, y, xx, yy) { this.doc.line(x, y, xx, yy) }
f1pdf.prototype.save = function(filename) { return this.doc.save(filename) }
f1pdf.prototype.setDrawColor = function(x) { this.doc.setDrawColor(x) }
f1pdf.prototype.setTextColor = function(x) { this.doc.setTextColor(x) }
f1pdf.prototype.setFontSize = function(x) { this.doc.setFontSize(x) }
f1pdf.prototype.addSubTitle = function(s, i, align = 'left') {
  this.addSpacing(0.5)
  this.doc.setTextColor("#000000")
  this.doc.setFontSize(12);
  // doc.setFontStyle("bold");
  this.addPage();
  this.doc.text(s, this.baseX + (i * 5), this.finalY, align)
  this.finalY += this.pSpacing
  this.resetTextStyle()
  return i< 0 ? i * -1 : this.baseX + (i * 5)
}
f1pdf.prototype.addTitle = function(s, i, align = 'left') {
  this.doc.setTextColor("#3e63ba")
  this.doc.setFontSize(16);
  // doc.setFontStyle("bold");
  this.addPage();
  this.doc.text(s, this.baseX + (i * 5), this.finalY, align)
  this.finalY += this.pSpacing
  this.resetTextStyle()
  return i< 0 ? i * -1 : this.baseX + (i * 5)
}
f1pdf.prototype.addLastPage = function(s, i, gap = 1, align = 'center') {
  this.doc.text(s, this.baseX + (i * 5), this.finalY, align)
  this.addSpacing(gap)
  return i< 0 ? i * -1 : this.baseX + (i * 5)
}
f1pdf.prototype.addText = function(s, i, align = 'center') {
  this.addPage();
  this.doc.text(s, this.baseX + (i * 5), this.finalY, align)
  this.finalY += this.pSpacing
  return i< 0 ? i * -1 : this.baseX + (i * 5)
}
f1pdf.prototype.addPage = function(h = 0, force = false) {
  let pageHeight = this.doc.internal.pageSize.height;
  if(this.finalY + this.baseY + h > pageHeight || force) {
    this.doc.addPage();
    this.initPage()
  }
}
f1pdf.prototype.addSpacing = function(i) { this.addPage(); this.finalY += this.pSpacing * i }
f1pdf.prototype.initPage = function(doc) { this.finalY = this.baseY; this.doc = doc ? doc : this.doc }
f1pdf.prototype.resetTextStyle = function() {
  // doc.setFontStyle("normal");
  this.doc.setFontSize(9);
  this.doc.setTextColor("#000000");
}

f1pdf.prototype.getDataUri = function(url) {
  return new Promise(resolve => {
      var image = new Image();
      image.setAttribute('crossOrigin', 'anonymous'); //getting images from external domain

      image.onload = function () {
          var canvas = document.createElement('canvas');
          canvas.width = this.naturalWidth;
          canvas.height = this.naturalHeight;

          //next three lines for white background in case png has a transparent background
          var ctx = canvas.getContext('2d');
          ctx.fillStyle = '#fff';  /// set white fill style
          ctx.fillRect(0, 0, canvas.width, canvas.height);

          canvas.getContext('2d').drawImage(this, 0, 0);

          resolve(canvas.toDataURL('image/jpeg', 1.0));

          setTimeout(() => resolve(''), 1000)
      };

      image.src = url;
  })
}

export default f1pdf
